/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Least_Nuthatch_WinInputs */

const fr_warm_least_nuthatch_win = /** @type {(inputs: Warm_Least_Nuthatch_WinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` types sélectionnés`)
};

/**

* @param {Warm_Least_Nuthatch_WinInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const warm_least_nuthatch_win = /** @type {((inputs?: Warm_Least_Nuthatch_WinInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Least_Nuthatch_WinInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_warm_least_nuthatch_win(inputs)
});